import { useState, useEffect } from "react";

const useDelayedRender = (delay) => {
  const [shouldRender, setShouldRender] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setShouldRender(true), delay);
    return () => clearTimeout(timer);
  }, [delay]);

  return { shouldRender };
};

export default useDelayedRender;
